import styles from './index.module.scss'
import ModelLeftCom from './components/ModelLeftCom'
import FeedbackText from './components/FeedbackText';

const PicModalLeft = (props) => {
    const { item } = props

    return (
        <div className={styles.PicModalLeft}>
            <ModelLeftCom item={item} selectedInputImg={props.selectedInputImg} setSelectedInputImg={props.setSelectedInputImg} />
            <FeedbackText key={item.taskId} {...props} />
        </div>
    )
}

export default PicModalLeft